import { addPlaceholder } from './descriptor';
export const addLinkPlaceholder = (deps) => (state, dispatch) => {
    if (!state.selection.empty)
        return false;
    dispatch === null || dispatch === void 0 ? void 0 : dispatch(addPlaceholder(state.tr, deps).scrollIntoView());
    return true;
};
